import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Alert } from 'react-bootstrap';
import Loading from '../components/Loading.jsx';
import SignInFormContainer from '../containers/auth/SignInFormContainer.jsx';
import { isSignedIn } from '../lib/session.js';
import { retrieveUser } from '../modules/auth.js';

const Index = ({ retrieveUser }) => {
  const [signedIn, setSignedIn] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const error = searchParams.get('error');
  const slug = searchParams.get('slug');
  const organization_slug = searchParams.get('organization_slug');

  useEffect(() => {
    // Don't attempt to retrieve user if no access token exists
    // This prevents refresh token from being used after explicit logout
    if (!isSignedIn()) {
      setSignedIn(false);
      return;
    }

    retrieveUser({ organization_slug: slug })
      .then((response) => {
        response.user.organizations.forEach((o) =>
          localStorage.setItem(
            `${o.slug}_CUSTOM_NAMING_SETTING`,
            JSON.stringify(o.customNaming)
          )
        );

        const firstOrgSlug = response.user.organizations[0].slug;

        if (error) {
          setTimeout(() => {
            navigate(`/${firstOrgSlug}/projects`, { replace: true });
          }, 7000);
        } else {
          navigate(`/${firstOrgSlug}/projects`, { replace: true });
        }
      })
      .catch(() => {
        setSignedIn(false);
      });
  }, [retrieveUser, slug, error, navigate]);

  return (
    <div className="component-centered">
      <Helmet>
        <title>ChangeSync</title>
      </Helmet>
      {error && <Alert bsStyle="danger">{error}</Alert>}
      {signedIn === false ? (
        <SignInFormContainer organizationSlug={organization_slug} />
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default connect(null, { retrieveUser })(Index);
